import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, SkeletonText } from "@chakra-ui/react"
import countries from "@/data/countries";
import { COLORS } from "@/common/constants";
import { useNavigate } from 'react-router-dom';

const TableGroupedShipOwner = ({
    dataList,
    isLoading,
}: any) => {
    const navigate = useNavigate();
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Company Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Country</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Contact Person</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Email</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Phone </Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Action</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        {isLoading && (
                            <Tr>
                                <Td colSpan={8}>
                                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                                </Td>
                            </Tr>
                        )}

                        {!isLoading && (!dataList || dataList.length === 0) && (
                            <Tr>
                                <Td colSpan={8} textAlign="center">Data not found</Td>
                            </Tr>
                        )}

                        {!isLoading && dataList?.map((item: any) => {
                            return (
                                <Tr
                                    key={item.id}
                                >
                                    <Td>{item.onBehalfCompany}</Td>
                                    <Td>{countries?.find((x: any) => x.value === item.country)?.label || "-"}</Td>
                                    <Td>{item.contactPerson}</Td>
                                    <Td>{item.email}</Td>
                                    <Td>{item.phone}</Td>
                                    <Td>
                                        <button
                                            style={{
                                                background: "#f79009",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "50px",
                                                padding: "6px 16px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                transition: "background 0.2s ease",
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = "#d67e00")}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = "#f79009")}
                                            onClick={() => {
                                                const company = item.onBehalfCompany
                                                    ?.toLowerCase()
                                                    .replace(/[0-9#()]/g, "");
                                                navigate(`/manage-ship-operator?search=${encodeURIComponent(company)}`);
                                            }}
                                        >
                                            View Child
                                        </button>


                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </Box>
        </TableContainer>
    )
}

export default TableGroupedShipOwner;
